import { useState } from 'react'
import { ChevronDown, ChevronRight } from 'lucide-react'
import { Checkbox } from '../../ui/checkbox'
import type { FacetBucket } from './types'

export function bucketIndex(buckets: FacetBucket[] | undefined): Map<string, number> {
  const map = new Map<string, number>()
  if (!buckets) return map
  for (const b of buckets) map.set(b.value, b.count)
  return map
}

export function mergeValues(
  canonical: string[],
  buckets: FacetBucket[] | undefined,
): string[] {
  if (!buckets) return canonical
  const seen = new Set(canonical)
  const extras = buckets
    .map((b) => b.value)
    .filter((v) => !seen.has(v) && v !== '')
  return [...canonical, ...extras]
}

export function OptionCheckbox({
  label,
  count,
  checked,
  disabled,
  onToggle,
}: {
  label: string
  count: number | undefined
  checked: boolean
  disabled: boolean
  onToggle: () => void
}) {
  return (
    <div
      className={`flex items-center justify-between gap-2 ${disabled ? 'opacity-60' : ''}`}
    >
      <Checkbox
        label={label}
        checked={checked}
        disabled={disabled}
        onCheckedChange={() => {
          if (!disabled) onToggle()
        }}
      />
      {count !== undefined && (
        <span className="text-xs text-neutral-600 tabular-nums">{count}</span>
      )}
    </div>
  )
}

export function FilterSection({
  title,
  children,
  defaultOpen = false,
}: {
  title: string
  children: React.ReactNode
  defaultOpen?: boolean
}) {
  const [open, setOpen] = useState(defaultOpen)

  return (
    <div className="border-t border-neutral-100 pt-4">
      <button
        onClick={() => setOpen((o) => !o)}
        className="flex items-center justify-between w-full text-xs font-semibold text-neutral-600 uppercase tracking-wide mb-2"
      >
        {title}
        {open ? (
          <ChevronDown className="h-3.5 w-3.5" />
        ) : (
          <ChevronRight className="h-3.5 w-3.5" />
        )}
      </button>
      {open && <div className="flex flex-col gap-2">{children}</div>}
    </div>
  )
}
